// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"50534031","54":"ed73b203","87":"b17875f8","191":"e277bde6","319":"a398f7d6","373":"29d1aea2","409":"98048f87","436":"520f79b3","899":"ff5855f2","937":"558da424","942":"482f09c6","973":"b9669b52","995":"f1406dfd"}[chunkId] + ".chunk.css";
};